// @flow
import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PickupInstructions as InstructionsBlock } from '../../confirmation/PickupInstructions';
import { mapStateToProps } from '../YourTrip/builder';
import { FormattedMessage } from 'mz-intl';
import getTimeString from 'mz-utils/getTimeString';
import messages from '../messages.intl';

type Props = {
  details: Object,
  heading: Object,
};

const PickupInstructions = ({ heading, details }: Props) => {
  const isHourlyRide =
    details.hourlyDetails && details.hourlyDetails.hoursRequested;

  if (!isHourlyRide) return null;

  const numHours = getTimeString({
    m: moment(),
    hourDiff: details.hourlyDetails.hoursRequested,
  });
  const providerName = heading.providerNames ? heading.providerNames[0] : '';

  return (
    <FormattedMessage
      message={messages.HOURLY_PICKUP_INSTRUCTIONS}
      values={{ numHours, providerName }}
    >
      {(instructionsMessage) => (
        <InstructionsBlock
          numVehicles={heading.numVehicles}
          instructions={instructionsMessage}
        />
      )}
    </FormattedMessage>
  );
};

export default compose(connect(mapStateToProps))(PickupInstructions);
